module.exports = __webpack_public_path__ + "img/park-bgtop2.e343d4d8.png";